var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#2b2d2f;stroke-linecap:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_46855"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_2292",
    className: "cls-1",
    x1: 10.5,
    y1: 10.5,
    x2: 0.5,
    y2: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2293",
    className: "cls-1",
    x1: 5.5,
    y1: 0.5,
    x2: 5.5,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2294",
    className: "cls-1",
    x1: 9.5,
    y1: 4.5,
    x2: 5.5,
    y2: 8.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2295",
    className: "cls-1",
    x1: 1.5,
    y1: 4.5,
    x2: 5.5,
    y2: 8.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d5ab8ec9f3a74913350c55593b44da3f.svg";
export { ForwardRef as ReactComponent };